import { useMemo, useState } from 'react'
import { Col, Form, Modal, Row, Table } from 'react-bootstrap'
import { useOrdenation } from '../../hooks/useOrdenation'
import { Ask } from '../Ask'
import { Center } from '../Center'

export function ModalPessoas({ isOpen, onClose, data, onSelect, title }) {
  const [search, setSearch] = useState('')

  const filteredPessoas = useMemo(() => {
    let dataFiltered = data

    if (search) {
      dataFiltered = dataFiltered.filter((pessoa) =>
        String(pessoa.nome).toLowerCase().includes(search.toLowerCase()),
      )
    }

    return dataFiltered
  }, [data, search])

  const { filteredItems, Th, Paginate } = useOrdenation(
    filteredPessoas,
    'nome',
    'asc',
  )

  function handleSelect(pessoa) {
    onSelect(pessoa)
    onClose()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <>
          {data.length === 0 ? (
            <Center column>
              <p>Não encontramos nada :(</p>
            </Center>
          ) : (
            <>
              <Row>
                <Col>
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Digite aqui..."
                  />
                </Col>
              </Row>
              <Table
                hover
                striped
                bordered
              >
                <thead>
                  <tr>
                    <Th
                      label="ID"
                      value="id"
                    />
                    <Th
                      label="Nome"
                      value="nome"
                    />
                  </tr>
                </thead>

                <tbody>
                  {filteredItems.map((data) => (
                    <tr
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        Ask(`Selecionar ${data.nome}?`, () =>
                          handleSelect(data),
                        )
                      }
                    >
                      <td>{data.id}</td>
                      <td>{data.nome}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Paginate />
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  )
}
